import React from 'react';

const Unauthorized: React.FC = () => {
  const handleRetry = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.href = '/';
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: 'Inter, system-ui, sans-serif'
    }}>
      <img
        src="/joule-logo.png"
        alt="Joule"
        style={{ height: '2.5rem', marginBottom: '2rem' }}
      />
      <div style={{
        backgroundColor: 'white',
        padding: '3rem',
        borderRadius: '0.5rem',
        boxShadow: '0 0.125rem 0.5rem rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '28rem'
      }}>
        <div style={{
          width: '3.5rem',
          height: '3.5rem',
          borderRadius: '50%',
          backgroundColor: '#fee2e2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.5rem'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>
        <h2 style={{ margin: '0 0 1rem 0', color: '#333', fontSize: '1.25rem' }}>
          Access Denied
        </h2>
        <p style={{ color: '#666', marginBottom: '2rem', fontSize: '0.875rem', lineHeight: '1.5' }}>
          You do not have access to this application. Please contact your administrator to request access.
        </p>
        <button
          onClick={handleRetry}
          style={{
            backgroundColor: '#1a1a2e',
            color: 'white',
            border: 'none',
            padding: '0.625rem 1.5rem',
            borderRadius: '0.25rem',
            cursor: 'pointer',
            fontSize: '0.875rem'
          }}
        >
          Sign in with a different account
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
